import moment from "moment";
import React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TaskManagement from "../task_management";
import Box from "../../../components/Box/Box";
import { Button, Progress, Space, Typography } from "antd";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
const { Title, Text } = Typography;


const getTimeDuration = (startTime: string | Date): string => {
    const start = new Date(startTime);
    const now = new Date();
    const diffMs = now.getTime() - start.getTime();

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    return `${hours}:${minutes}:${seconds}`;
};

const extractTime = (isoString: string): Date => {
    const date = new Date(isoString);
    const now = new Date();
    now.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), 0);
    return now;
};


const Timesheet = () => {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const { user } = useSelector((state: any) => state.app);
    const [attendance, setAttendance] = useState<any>(null);
    const [timeText, setTimeText] = useState('0:0:0');
    const [currentTime, setCurrentTime] = useState(moment().format('hh:mm:ss A'));
    const [progress, setProgress] = useState(0);
    const dispatch = useDispatch()

    const getCurrentStatus = async () => {
        const resData = await dispatch(getData('/attendance-logs'))
        if (resData) {
            setAttendance(resData.data)
        }
    }

    useEffect(() => {
        getCurrentStatus()
    }, [])

    useEffect(() => {
        if (attendance) {
            const updateProgress = () => {
                setTimeText(getTimeDuration(attendance?.startDate))
                const today = new Date().toLocaleString("en-US", { weekday: "long" }); // Get current day
                const todaySchedule = user?.shiftType?.shiftTimings[today as keyof typeof user.shiftType.shiftTimings];

                if (!todaySchedule) {
                    setProgress(0);
                    return;
                }

                const startTime = extractTime(todaySchedule.start);
                const endTime = extractTime(todaySchedule.end);
                const now = new Date();

                const totalWorkMs = endTime.getTime() - startTime.getTime();
                const elapsedMs = now.getTime() - new Date(attendance?.startDate).getTime();
                const percentComplete = (elapsedMs / totalWorkMs) * 100;
                setProgress(Math.min(100, percentComplete));
            };

            const interval = setInterval(() => updateProgress(), 1000);

            return () => clearInterval(interval);
        } else {
            const interval = setInterval(() => {
                setCurrentTime(moment().format('hh:mm:ss A'))
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [attendance?.startDate]);



    const showModal = () => {
        setIsModalVisible(true)
    };

    const handleConfirm = () => {
        setIsModalVisible(false)
        getCurrentStatus();
    };

    const handleCancel = () => {
        console.log('Cancelled!');
        setIsModalVisible(false)
    };


    const askForStatus = () => {
        showModal();
    };


    return <>
        {isModalVisible && React.cloneElement(<TaskManagement
            attendance={attendance}
            open={isModalVisible}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
        />)}
        <Box
            title={'Timesheet'}>
            <div className="flex justify-center items-center h-full w-full">
                {attendance ? <>
                    <div className="flex flex-row justify-evenly items-center bg-white p-4 space-x-4" >
                        <Space>
                            <Progress
                                percent={progress}
                                type="dashboard"
                                size={"default"}
                                key={1}
                                format={(date) => timeText}
                            />
                        </Space>
                        <Space direction="vertical" className="contact_info">
                            <div>
                                <Title className="noLine" level={5}>Check in at</Title>
                                <Text type="secondary">{moment(attendance?.startDate).format('lll')}</Text>
                            </div>
                            <div>
                                <Button type="default" onClick={() => askForStatus()}>Clock out</Button>
                            </div>
                        </Space>
                    </div>
                </> : <>
                    <div className="flex flex-row justify-evenly items-center bg-white p-4 space-x-4" >
                        <Space>
                            <Progress
                                percent={0}
                                type="dashboard"
                                size={"default"}
                                key={1}
                                format={(date) => currentTime}
                            />
                        </Space>
                        <Space direction="vertical" className="contact_info">
                            <div>
                                <Title className="noLine" level={5}>Mark Your Attendance</Title>
                                <Text type="secondary">Click the "Clock In" button to mark your attendance for today.</Text>
                            </div>
                            <div>
                                <Button type="default" onClick={() => askForStatus()}>Clock In</Button>
                            </div>
                        </Space>
                    </div>
                </>}
            </div>
            <div className="flex justify-center">
                <Text>
                    Note: Clock-in is allowed only once per day, so do not clock out if you haven't finished your day.
                </Text>
            </div>
        </Box>
    </>
}

export default Timesheet;